import { createSlice } from '@reduxjs/toolkit';
import { getAllLookup } from './lookupService';

const initialState = {
    allLookup: {
        isLookupLoading: null,
        isLookupSuccess: null,
        lookupMessage: null,
        pageCount: 0,
        data: [],
    },
};

const lookupSlice = createSlice({
    name: 'lookup',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // PENDING
        builder
            .addCase(getAllLookup.pending, (state) => {
                state.allLookup = {
                    ...initialState.allLookup,
                    isLookupLoading: true,
                    lookupMessage: 'Loading',
                };
            })
            .addCase(getAllLookup.rejected, (state, action) => {
                state.allLookup = {
                    ...initialState.allLookup,
                    isLookupLoading: false,
                    isLookupSuccess: false,
                    lookupMessage: action.payload || 'Error occurred while fetching Lookup',
                };
            })
            .addCase(getAllLookup.fulfilled, (state, action) => {
                state.allLookup = {
                    ...initialState.allLookup,
                    isLookupLoading: false,
                    isLookupSuccess: true,
                    pageCount: action.payload.pageCount || 0,
                    data: action.payload.data || [],
                };
            });
    }
});

export default lookupSlice.reducer;
